import styles from './styles.module.css';
import { getManualCrop, getImageWithManualCrop } from "@/shared/functions/getImagesFunctions";

const MainImageTemplate = ({ related, relatedProps }) => {
    const mainImageData = related?.images?.[0];
    if (!mainImageData) return null;

    const { desktop, tablet, mobile } = relatedProps.customClippings;

    const desktopManualCrop = getManualCrop(mainImageData?.value, desktop);

    const dataMainImage = desktopManualCrop
        ? desktopManualCrop
        : mainImageData?.value?.clippings?.find(el => el._id === desktop)
    const { width, height } = dataMainImage?.dimensions ?? {}

    const getFullUrl = (clippingId) => {
        const imageObject = getImageWithManualCrop(mainImageData.value, clippingId);
        return imageObject ? (imageObject.domain + imageObject.imgUrl) : '';
    };

    const desktopImageUrl = getFullUrl(desktop);
    const tabletImageUrl = getFullUrl(tablet);
    const mobileImageUrl = getFullUrl(mobile);

    return (
        <div className={styles['article-image-epi']}>
            <picture>
                <source media="(min-width: 770px)" srcSet={desktopImageUrl} />
                <source media="(min-width: 400px)" srcSet={tabletImageUrl} />
                <img
                    src={mobileImageUrl}
                    alt={mainImageData.epigraphe || "Imagen principal de la nota"}
                    width={width}
                    height={height}
                    className={styles['cover-image']}
                />
            </picture>
            <span className={styles["epigraphe"]}>{mainImageData.epigraphe}</span>
        </div>
    );
};

export default MainImageTemplate;